import React from 'react';
import { Navigate, RouteObject, createBrowserRouter } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Bookmarks from './pages/Bookmarks';
import { Favorites } from './pages/Favorites';
import Auth from './pages/Auth';
import { BookmarkGallery } from './components/BookmarkGallery';
import Settings from './pages/Settings';
import AdminSettings from './pages/AdminSettings';
import { getCurrentUser, hasPermission } from './utils/authUtils';
import { UserRole } from './types/user';

// 权限控制组件
const ProtectedRoute: React.FC<{ 
  element: React.ReactElement; 
  requiredRole?: UserRole;
}> = ({ element, requiredRole }) => {
  const currentUser = getCurrentUser();
  
  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  if (requiredRole && !hasPermission(requiredRole)) {
    return <Navigate to="/" replace />;
  }

  return element;
};

// 公开路由组件
const PublicRoute: React.FC<{ 
  element: React.ReactElement;
}> = ({ element }) => {
  const currentUser = getCurrentUser();
  
  if (currentUser) {
    return <Navigate to="/" replace />;
  }

  return element;
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <ProtectedRoute element={<Home />} />,
      },
      {
        path: 'bookmarks',
        element: <ProtectedRoute element={<Bookmarks />} requiredRole={UserRole.ADMIN} />,
      },
      {
        path: 'gallery',
        element: <ProtectedRoute element={<BookmarkGallery />} />,
      },
      {
        path: 'favorites',
        element: <ProtectedRoute element={<Favorites />} />,
      },
      {
        path: 'settings',
        element: <ProtectedRoute element={<Settings />} />,
      },
      {
        path: 'admin',
        element: <ProtectedRoute element={<AdminSettings />} requiredRole={UserRole.SUPER_ADMIN} />,
      },
    ],
  },
  {
    path: '/auth',
    element: <PublicRoute element={<Auth />} />,
  },
]); 